import { render, staticRenderFns } from "./importproducttemplate.vue?vue&type=template&id=6a207858"
import script from "./importproducttemplate.vue?vue&type=script&lang=js"
export * from "./importproducttemplate.vue?vue&type=script&lang=js"
import style0 from "./importproducttemplate.vue?vue&type=style&index=0&id=6a207858&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports